import React, { Context } from 'react';

export const TokenContext: Context<string> = React.createContext<string>('');
